import React, { useRef, useEffect } from 'react';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useGameStore } from '@/store/gameStore';

const MoveHistory = () => {
  const { history, currentMoveIndex, boardTheme } = useGameStore();
  const scrollRef = useRef(null);
  
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [history.length]);
  
  // Group moves into pairs
  const movePairs = [];
  for (let i = 0; i < history.length; i += 2) {
    movePairs.push({
      number: Math.floor(i / 2) + 1,
      white: history[i],
      black: history[i + 1] || null,
      whiteIndex: i,
      blackIndex: i + 1
    });
  }
  
  return (
    <div 
      className={`
        rounded-xl p-4
        ${boardTheme === 'cosmic' 
          ? 'bg-slate-900/80 border border-purple-500/30' 
          : 'bg-amber-50 border border-amber-200'
        }
      `}
      data-testid="move-history"
    >
      <h3 className={`
        text-sm font-bold tracking-wider uppercase mb-3
        ${boardTheme === 'cosmic' ? 'text-purple-400' : 'text-amber-800'}
      `}>
        Move History
      </h3>
      
      <ScrollArea className="h-40" ref={scrollRef}>
        {movePairs.length === 0 ? (
          <p className={`text-sm italic ${boardTheme === 'cosmic' ? 'text-gray-500' : 'text-gray-400'}`}>
            No moves yet...
          </p>
        ) : (
          <table className="w-full text-sm font-mono">
            <tbody>
              {movePairs.map((pair) => (
                <tr 
                  key={pair.number}
                  className={`border-b ${boardTheme === 'cosmic' ? 'border-purple-900/30' : 'border-amber-200'}`}
                >
                  <td className={`py-1 pr-2 w-8 ${boardTheme === 'cosmic' ? 'text-gray-500' : 'text-gray-400'}`}>
                    {pair.number}.
                  </td>
                  <td 
                    className={`
                      py-1 px-2 cursor-pointer rounded transition-colors
                      ${currentMoveIndex === pair.whiteIndex 
                        ? boardTheme === 'cosmic'
                          ? 'bg-cyan-500/30 text-cyan-300'
                          : 'bg-amber-300 text-amber-900'
                        : boardTheme === 'cosmic'
                          ? 'text-gray-300 hover:bg-purple-900/30'
                          : 'text-gray-700 hover:bg-amber-100'
                      }
                    `}
                    data-testid={`move-${pair.whiteIndex}`}
                  >
                    {pair.white}
                  </td>
                  <td 
                    className={`
                      py-1 px-2 cursor-pointer rounded transition-colors
                      ${pair.black 
                        ? currentMoveIndex === pair.blackIndex 
                          ? boardTheme === 'cosmic'
                            ? 'bg-cyan-500/30 text-cyan-300'
                            : 'bg-amber-300 text-amber-900'
                          : boardTheme === 'cosmic'
                            ? 'text-gray-300 hover:bg-purple-900/30'
                            : 'text-gray-700 hover:bg-amber-100'
                        : ''
                      }
                    `}
                    data-testid={pair.black ? `move-${pair.blackIndex}` : undefined}
                  >
                    {pair.black || ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </ScrollArea>
    </div>
  );
};

export default MoveHistory;
